import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { BAN_POLICY_STATEMENT, CURRENTLY_BANNED_SPECIES } from "../data/fishingBanStatus";

export default function FishingBanStatement() {
  return (
    <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-ocean-900/5 sm:p-8">
      <div className="flex items-start gap-4">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-400/15 text-teal-600">
          <ShieldCheck className="h-5 w-5" strokeWidth={1.5} />
        </div>
        <p className="text-sm leading-relaxed text-ocean-800/80">{BAN_POLICY_STATEMENT}</p>
      </div>

      <div className="mt-6 border-t border-ocean-900/5 pt-6">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-ocean-800/60">
          Currently Banned Species by Region
        </h3>
        {CURRENTLY_BANNED_SPECIES.length === 0 ? (
          <p className="mt-2 text-sm text-ocean-800/60">
            A live, region-by-region list is being integrated from our internal ban-tracking system —
            check back here for real-time status.
          </p>
        ) : (
          <ul className="mt-3 space-y-2">
            {CURRENTLY_BANNED_SPECIES.map((ban) => (
              <li key={ban.id} className="rounded-xl bg-foam-50 p-3 text-sm">
                <span className="font-semibold text-ocean-950">{ban.species}</span>
                <span className="text-ocean-800/60"> — {ban.region}</span>
                <p className="mt-1 text-xs text-ocean-800/50">
                  {ban.banStart} – {ban.banEnd} · Source: {ban.regulatorySource}
                </p>
              </li>
            ))}
          </ul>
        )}
      </div>

      <p className="mt-6 text-xs text-ocean-800/50">
        This statement is part of our full compliance framework — see{" "}
        <Link to="/compliance" className="font-semibold text-teal-600 hover:text-teal-700">
          Compliance &amp; Food Safety
        </Link>
        .
      </p>
    </div>
  );
}
